"use strict";
const _ = require('lodash');
_.mixin(require('lodash-uuid'));
module.exports = entity => {
    let ensuredEntity = {
        ...entity,
    };
    if (!entity.currency) {
        ensuredEntity.currency = _.get(entity, 'supplier.currency') || 'SEK';
    }
    if (entity.customerType || entity.chain) {
        ensuredEntity = { ...ensuredEntity, discountAgreements: [] };
    }
    ensuredEntity.priceListEntries = _.uniqBy((ensuredEntity.priceListEntries || []).map(entry => ({
        ...entry,
        id: `${entity.id}-${_.get(entry, 'article.id', _.uuid())}`,
    })), 'id');
    ensuredEntity.discountAgreements = _.uniqBy((ensuredEntity.discountAgreements || []).map(agreement => ({
        ...agreement,
        id: `${entity.id}-${_.get(agreement, 'customerSubUnit.id', _.get(agreement, 'supplierCustomer.id', _.uuid()))}`,
    })), 'id');
    return ensuredEntity;
};
